import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck'
import StraightenIcon from '@mui/icons-material/Straighten'
import Carousel from '../control/Carousel'

const data = [1, 2, 3, 4, 5]
const carouselResponsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
    1280: { items: 4 },
}

const CarouselPlaygroundView = () => {
    const classes = useStyles()

    return (
        <Grid container>
            <Typography variant="h3" gutterBottom>
                Control: Carousel
            </Typography>
            <Carousel responsiveSetting={carouselResponsive} disableButtonsControls>
                {data.map((item, index) => (
                    <Box component="div" key={index}>
                        <Paper className={classes.paper}>
                            <Grid container justifyContent="space-around" alignItems="center" spacing={1}>
                                <Grid item md={12} className={classes.subtitle1}>
                                    <Typography variant="body1" gutterBottom component="div">
                                        กรุงเทพฯ (ความถี่หลังปรับ {data.length - index} MHz)
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container justifyContent="space-around" alignItems="center" spacing={1}>
                                <Grid item md={6} className={classes.subtitle2}>
                                    <NetworkCheckIcon />
                                    <Typography variant="subtitle2" gutterBottom component="div">
                                        สัญญาณดี
                                    </Typography>
                                </Grid>
                                <Grid item md={6} className={classes.subtitle2}>
                                    <StraightenIcon />
                                    <Typography variant="subtitle2" gutterBottom component="div">
                                        {item} km
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                ))}
            </Carousel>
        </Grid>
    )
}

//Controller
const CarouselPlayground = () => {
    return <CarouselPlaygroundView />
}

export default CarouselPlayground

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    subtitle1: {
        display: 'flex',
        justifyContent: 'center',
    },
    subtitle2: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
    },
}))
